import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../../components/Table";
import { SecuronixViolationsColumns } from "../../../../components/headerContent";
import RowViolation from "./RowViolation";
import Loader from "../../../../components/Loader";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import NumberCard from "../../../../components/Card/NumberCard";
import { useTranslation } from "react-i18next";

export default function Violation({ date }) {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getviolations = async () => {
        const generationtime_from = new Date(date[1]);
        const generationtime_to = new Date(date[0]);

        const formatted_generationtime_to = `${(generationtime_from.getMonth() + 1).toString().padStart(2, '0')}/${generationtime_from.getDate().toString().padStart(2, '0')}/${generationtime_from.getFullYear()} 00:00:00`;
        const formatted_generationtime_from = `${(generationtime_to.getMonth() + 1).toString().padStart(2, '0')}/${generationtime_to.getDate().toString().padStart(2, '0')}/${generationtime_to.getFullYear()} 23:59:59`;

        const res = await axios(`${apiUrl}securonix/violations/${new Date(formatted_generationtime_from).getTime()}/${new Date(formatted_generationtime_to).getTime()}`, {
            method: "get",
            withCredentials: true
        });

        return res.data;
    };

    const violations = useQuery({
        queryKey: ["violations", date],
        queryFn: getviolations,
        enabled: true,
    });

    useEffect(() => {
        violations.refetch();
    }, [date, violations]);

    const getUsersthreats = async () => {
        const res = await axios(`${apiUrl}securonix/users`, {
            method: "get",
            withCredentials: true
        });

        return res.data;
    };

    const userThreats = useQuery({
        queryKey: ["userThreats"],
        queryFn: getUsersthreats,
        enabled: true,
    });

    return (
        <>
            {!violations.isLoading ? (
                <>
                    {userThreats.data && userThreats.data.length > 0 && (
                        <section className="page-section">
                            <NumberCard
                                title={t("Nombre total d'interactions des utilisateurs avec des menaces, répertoriées par Securonix") + " :"}
                                number={userThreats.data.length}
                                logo={faCircleCheck}
                                color={"#AEC353"}
                                stylesIcons={"logo-certificats"}
                            />
                        </section>
                    )}
                     <div className='cato-content-table'>
                        <Table
                            tableData={violations.data}
                            tableColumns={SecuronixViolationsColumns}
                            checkbox={false}
                            rowComponent={RowViolation}
                        />
                    </div>
                </>
            ) : (
                <Loader />
            )}
        </>
    );
}